import { XSGlobalHeaderActions } from "@xinosolutions/xs-shell";
import { useAccountMenuUser, useAuthActions } from "@xinosolutions/xs-auth-react";
import { xsAccountUrl } from "../../config/config";
import { useAdminLogout } from "../../Hooks/useAdminLogout";

/**
 * Same account control as xs-template-admin-app
 * (XSGlobalHeaderActions from @xinosolutions/xs-shell).
 */
export default function ShellAccountActions({
  manageAccountUrl = xsAccountUrl || "https://account.xinosolutions.com/dashboard",
  manageAccountLabel = "Manage your XS Account",
  beforeAccount,
}) {
  const menuUser = useAccountMenuUser();
  const { switchAccount, addAccount, pending } = useAuthActions({
    notifyError: true,
  });
  const { signOut, pending: signOutPending } = useAdminLogout({
    homePath: "/",
  });

  return (
    <XSGlobalHeaderActions
      user={menuUser}
      manageAccountUrl={manageAccountUrl}
      manageAccountLabel={manageAccountLabel}
      beforeAccount={beforeAccount}
      onSwitchAccount={() => {
        switchAccount().catch(() => {});
      }}
      onAddAccount={() => {
        addAccount().catch(() => {});
      }}
      onSignOut={() => {
        signOut().catch(() => {});
      }}
      switchPending={pending}
      signOutPending={signOutPending}
    />
  );
}
